import styled from 'styled-components';

export const ReviewCardContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.lighter};
`;

export const CardContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;

  h3 {
    margin: 0;
    color: ${({ theme }) => theme.colors.neutral.dark};
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
    letter-spacing: 0.15px;
  }

  svg {
    font-size: 28px;
    fill: ${({ theme }) => theme.colors.yellow.default};
  }
`;
